import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=817b658c&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=817b658c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817b658c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('817b658c')) {
      api.createRecord('817b658c', component.options)
    } else {
      api.reload('817b658c', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=817b658c&scoped=true&", function () {
      api.rerender('817b658c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Hy3XL3PKK4Vk/JS/comp/CookieBox.vue"
export default component.exports